import React from 'react';

export interface ReviewDebitAgreementLabelProps {
    label?: string,
}

export const ReviewDebitAgreementLabel = ({ label }: ReviewDebitAgreementLabelProps): JSX.Element => (
    <div className="flex border border-red-300 p-4 mb-4 rounded-xl w-full justify-between bg-orange-100">
        {label ?? 'Please review your debit agreement to enable payment by bank transfers'}
    </div>
);
